import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Toaster } from 'react-hot-toast'

import App from './App'
import { IframeAuthProvider } from './contexts/IframeAuthProvider'
import './index.css'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Auth Provider wrapper component
const AuthProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <BrowserRouter>
      <IframeAuthProvider
        authDomain={import.meta.env.VITE_AUTH_DOMAIN || 'https://auth.staging.darwingov.com'}
        apiBaseUrl={import.meta.env.VITE_API_BASE_URL || 'https://api.staging.darwingov.com'}
        darwinLoginUrl={import.meta.env.VITE_DARWIN_LOGIN_URL || 'https://govern.staging.darwingov.com/login'}
        onNavigateToLogin={() => {
          window.location.href = '/login';
        }}
        getQueryParam={(param: string) => {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(param);
        }}
      >
        {children}
      </IframeAuthProvider>
    </BrowserRouter>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProviderWrapper>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              style: {
                background: '#16a34a',
              },
            },
            error: {
              style: {
                background: '#dc2626',
              },
            },
          }}
        />
      </AuthProviderWrapper>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
)